<div aria-live="polite" aria-atomic="true" class="toast-container position-fixed top-0 end-0 p-3 position-relative"
  style="overflow: hidden;" *ngIf="toast" style="z-index: 2000;">
  <div class="toast show shadow-sm rounded-3">

    <!-- Left color indicator -->
    <div class="rounded-top" [ngStyle]="{
    'border-top-color':
      toast.type === 'success'
        ? '#198754'
        : toast.type === 'error'
        ? '#dc3545'
        : '#f0ad4e'
  }" style="
    border-top-width: 4px;
    border-top-style: solid;
  "></div>

    <div class="container-fluid py-2">
      <div class="row align-items-center p-2">
        <!-- Icon -->
        <div class="col-1 p-1">
          <img width="22" height="22" [src]="
              toast.type === 'success'
                ? 'assets/icons/success.png'
                : toast.type === 'error'
                ? 'assets/icons/fail.png'
                : 'assets/icons/info.png'
            " alt="status icon" />
        </div>

        <!-- Text -->
        <div class="col-10">
          <div class="fw-semibold">{{ toast.title }}</div>
          <div class="text-muted small">{{ toast.message }}</div>
        </div>

        <!-- Close -->
        <div class="col-1">
          <button class="btn p-0 fw-bold text-secondary fs-4 text-center" (click)="close()">
            ×
          </button>
        </div>
      </div>
    </div>
  </div>
</div>